import { useMemo } from 'react';

export function formatPrice({
    amount,
    currencyCode,
    locale,
}: {
    amount: number;
    currencyCode: string;
    locale: string;
}) {
    const formatCurrency = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'code',
    });

    if (currencyCode === 'VND') {
        const formattedAmount = formatCurrency.format(amount);
        return formattedAmount.replace('VND', 'đ').replace(/\s/g, '');
    }

    return formatCurrency.format(amount);
}

export function formatVariantPrice({
    amount,
    baseAmount,
    currencyCode,
    locale,
}: {
    baseAmount: number;
    amount: number;
    currencyCode: string;
    locale: string;
}) {
    const hasDiscount = baseAmount > amount;
    const formatDiscount = new Intl.NumberFormat(locale, { style: 'percent' });
    const discountPercent = hasDiscount ? formatDiscount.format((baseAmount - amount) / baseAmount) : null;

    const price = formatPrice({ amount, currencyCode, locale });
    const basePrice = hasDiscount ? formatPrice({ amount: baseAmount, currencyCode, locale }) : null;
    const discount = hasDiscount ? formatPrice({ amount: baseAmount - amount, currencyCode, locale }) : null;

    return { price, basePrice, discount, discountPercent };
}

export function usePrice(
    data?: {
        amount: number;
        baseAmount?: number;
        currencyCode?: string;
    } | null
) {
    // @TODO: neeed to get from config
    const currency = 'VND';
    // @TODO: neeed to get from config
    const locale = 'vi';
    let currencyCode = data?.currencyCode || 'VND';
    const { amount, baseAmount } = {
        ...data,
    };
    if (currencyCode === undefined) {
        currencyCode = currency || 'VND';
    }
    const value = useMemo(() => {
        if (typeof amount !== 'number' || !currencyCode) return '';
        const currentLocale = locale ? locale : 'vi';
        return baseAmount
            ? formatVariantPrice({
                  amount,
                  baseAmount,
                  currencyCode,
                  locale: currentLocale,
              })
            : formatPrice({ amount, currencyCode, locale: currentLocale });
    }, [amount, baseAmount, currencyCode, locale]);

    return typeof value === 'string' ? { price: value, basePrice: null, discount: null, discountPercent: null } : value;
}

export function calculatePrice(data?: { amount: number; baseAmount?: number; currencyCode?: string } | null) {
    // @TODO: need to get from config
    const currency = 'VND';
    // @TODO: need to get from config
    const locale = 'vi';
    let currencyCode = data?.currencyCode || 'VND';
    const { amount, baseAmount } = { ...data };

    if (currencyCode === undefined) {
        currencyCode = currency || 'VND';
    }

    if (typeof amount !== 'number' || !currencyCode) return { price: '', basePrice: null, discount: null };

    const currentLocale = locale ? locale : 'vi';
    const value = baseAmount
        ? formatVariantPrice({
              amount,
              baseAmount,
              currencyCode,
              locale: currentLocale,
          })
        : formatPrice({ amount, currencyCode, locale: currentLocale });

    return typeof value === 'string' ? { price: value, basePrice: null, discount: null } : value;
}
